import { makeAutoObservable } from 'mobx';
import createStoreContext from '../createStoreContext';
import { CONFETTI_DURATION_MS } from 'src/constants/confetti';

export const [ConfettiStoreProvider, useConfettiStore] = createStoreContext(
  class ConfettiStore {
    isActive = false;
    private timeoutId: NodeJS.Timeout | null = null;

    public constructor() {
      makeAutoObservable(this);
    }

    trigger = () => {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      this.isActive = true;
      this.timeoutId = setTimeout(() => {
        this.isActive = false;
      }, CONFETTI_DURATION_MS);
    };

    reset = () => {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.isActive = false;
    };
  },
);

export type ConfettiStore = ReturnType<typeof useConfettiStore>;
